import React from 'react';
import clsx from 'clsx';

const Radio = React.forwardRef(({
  label,
  size = 'md',
  disabled = false,
  error = false,
  className,
  labelClassName,
  ...props
}, ref) => {
  const sizes = {
    sm: 'h-3.5 w-3.5',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  const labelSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  const inputClasses = clsx(
    'border-gray-300 text-primary transition-colors',
    'focus:ring-2 focus:ring-primary focus:ring-offset-1',
    error && 'border-red-400 text-red-600 focus:ring-red-500',
    disabled && 'cursor-not-allowed opacity-50',
    sizes[size],
    className
  );

  const input = (
    <input
      ref={ref}
      type="radio"
      className={inputClasses}
      disabled={disabled}
      aria-invalid={error}
      {...props}
      data-otg-component={props['data-otg-component'] || 'Radio'}
    />
  );

  if (!label) return input;

  return (
    <label
      className={clsx(
        'inline-flex items-center gap-2',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        labelSizes[size],
        'text-gray-700',
        labelClassName
      )}
      data-otg-component={props['data-otg-component'] || 'Radio'}
    >
      <input
        ref={ref}
        type="radio"
        className={clsx(
          'border-gray-300 text-primary transition-colors',
          'focus:ring-2 focus:ring-primary focus:ring-offset-1',
          error && 'border-red-400 text-red-600 focus:ring-red-500',
          disabled && 'cursor-not-allowed',
          sizes[size],
          className
        )}
        disabled={disabled}
        aria-invalid={error}
        {...props}
      />
      <span>{label}</span>
    </label>
  );
});

Radio.displayName = 'Radio';

export default Radio;
